import Util from './util/Util';
import FocusManagement from './util/FocusManagement';
import ExpandToggler from './components/ExpandToggler';

let hamburgerFocusLoop;

function init() {
  initHamburger();
  initPersistentMenu();
  initSearch();
}

function initHamburger() {
  Util.classToggler('.headerMenu__hamburger', 'headerHamburgerOpen', 'body', (isOn, el, parent, fnToggle) => {
    const elementsThatToggleToBlock = document.querySelectorAll('.headerMenu__menuWrap,.headerMenu__lang,.headerMenu__memberWrap')
    elementsThatToggleToBlock.forEach((wrap) => Util.prepDisplayNoneTransition(wrap, 'block'));

    const fnCloseMenu = () => fnToggle(false);
    
    if (isOn) {
      FocusManagement.onEsc(fnCloseMenu);
      rebuildHamburgerFocusLoop();
      FocusManagement.enableFocusLinks(hamburgerFocusLoop);
    }
    else {
      FocusManagement.offEsc(fnCloseMenu);
      FocusManagement.disableFocusLinks(hamburgerFocusLoop);
    }
  });
  
  ExpandToggler.init({
    toggleSelector : '.headerMenu__submenuToggle',
    parentSelector : '.menu-item',
    targetSelector : '.headerMenu__subNavWrap',
    ariaHiddenSelector: 'ul',
    parentExpandedClass : 'headerMenu__navItemWrap--expanded',
    onToggle: (isExpanded, targetEl) => {
      const tabIndex = (isExpanded ? '0' : '-1');
      targetEl.querySelectorAll('a, button').forEach(el => el.setAttribute('tabindex', tabIndex));
      rebuildHamburgerFocusLoop()
    }
  });
}

/**
 * Builds the focus-loop between header elements.  This focus loop is used when the hamburger menu is
 * open and prevents other site elements from being able to receive focus.
 */
function rebuildHamburgerFocusLoop() {
  hamburgerFocusLoop = FocusManagement.createFocusLoop([
    document.querySelector('.headerMenu__home'),
    document.querySelector('.headerMenu__hamburgerWrap'),
    document.querySelector('.headerMenu__menuWrap'),
    document.querySelector('.headerMenu__lang'),
    document.querySelector('.headerMenu__memberWrap'),
    document.querySelector('.headerMenu__searchButton'),
  ]);
}

function initPersistentMenu() {
  const headerEl = document.querySelector('.nst-siteHeader');
  if (!headerEl) { return; }
  
  let stuck = false;
  
  const fnSetHeaderStuck = () => {
    const shouldStick = (window.pageYOffset > 100);
    
    if (shouldStick === stuck) { return; }
    stuck = shouldStick;
    document.body.classList.toggle('nst-headerStuck', stuck);
  }
  
  document.addEventListener('scroll', fnSetHeaderStuck);
  fnSetHeaderStuck();
}

function initSearch() {
  const searchButton = document.querySelector('.headerMenu__searchButton');
  const searchBar = document.querySelector('.headerSearch__wrap');
  
  const fnToggleSearch = (isOpen = null) => {
    const classList = document.body.classList;
    Util.prepDisplayNoneTransition(searchBar, 'block');
    
    isOpen = (isOpen !== null) ? isOpen : !classList.contains('nst-headerSearch');
    classList.toggle('nst-headerSearch', isOpen);
    
    
    if (isOpen) {
      document.body.classList.remove('headerHamburgerOpen');
    }
  };
  
  searchButton.addEventListener('click', () => fnToggleSearch());
  
  const closeButton = document.querySelector('.headerSearch__close').addEventListener('click', () => fnToggleSearch(false));
}

export default { init };